<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-briefcase"></i></span>
    <h1>Careers at Tech Colleagues</h1>
    <p class="static-subtitle">Help us build the ERP small businesses actually want to use.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        We're a small, product-focused team building orderYaa ERP — from POS and inventory to
        accounting, manufacturing, and HR. We care about shipping things that work, not
        over-engineering things that look good in a demo.
      </p>

      <h2>What we look for</h2>
      <ul>
        <li>People who can own a feature end-to-end, not just a ticket</li>
        <li>Comfort talking to real customers and understanding their workflows</li>
        <li>A bias toward simple, maintainable solutions over clever ones</li>
      </ul>

      <h2>Open roles</h2>
      <p>
        We don't always have open roles listed here. If there's nothing posted right now, it
        doesn't mean we're not hiring — send us your CV and what you'd want to work on, and we'll
        reach out if there's a fit.
      </p>

      <div class="static-cta">
        <a
          class="btn"
          href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=hr@techcolleagues.com&amp;su=Job%20Application"
          target="_blank"
          rel="noopener noreferrer"
        >Send us your CV</a>
      </div>
    </div>
  </div>
</section>
